import { useState, useEffect } from 'react';

/**
 * Hook personnalisé pour gérer les compteurs de temps
 * Utilisé pour les durées de match, de jeu, et autres timers
 */
export function useTimer(startTime: number | null, isActive: boolean = true) {
  const [currentTime, setCurrentTime] = useState(Date.now());
  
  useEffect(() => {
    if (!isActive || !startTime) return;
    
    const interval = setInterval(() => {
      setCurrentTime(Date.now());
    }, 1000);
    
    return () => clearInterval(interval);
  }, [isActive, startTime]);
  
  if (!startTime) return 0;
  
  return Math.floor((currentTime - startTime) / 1000);
}

/**
 * Hook pour gérer l'état et la logique d'un timer modal
 */
export function useModalTimer() {
  const [timerModal, setTimerModal] = useState<{
    isOpen: boolean;
    timer: { name: string; duration: number } | null;
  }>({
    isOpen: false,
    timer: null
  });
  
  const openTimerModal = (timer?: { name: string; duration: number }) => {
    setTimerModal({
      isOpen: true,
      timer: timer || null
    });
  };
  
  const closeTimerModal = () => {
    setTimerModal({
      isOpen: false,
      timer: null
    });
  };
  
  return {
    timerModal,
    openTimerModal,
    closeTimerModal
  };
}